module.exports = __webpack_public_path__ + "static/img/man_teacher.952b3aa0.png";